import React, { useEffect, useState } from 'react';
import NavbarM from '../components/Navbar';
import Footer from '../components/Footer';
import mainLogo from '../img/mainLogo.svg';
import article1Image from '../img/latestNews/article.png';
import frame1 from '../img/latestNews/frame1.png';
import frame2 from '../img/latestNews/frame2.png';
import frame3 from '../img/latestNews/frame3.png';

const ArticlePage = () => {
    const [scroll, setScroll] = useState(false);
    const windowWide = window.innerWidth > 500;

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const handleScroll = () => setScroll(window.scrollY > 100);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <div className="heroMain">
                <div className={`heroSec heroSec--inner ${scroll ? 'heroSec__' : ''}`}>
                    <NavbarM logo={mainLogo} setNewsPage={() => {}} />
                </div>
                <div className="container" style={windowWide
                    ? { paddingTop: '150px', paddingBottom: '60px', backgroundColor: "rgba(255,255,255,0.5)", borderRadius: "30px" }
                    : { paddingTop: '100px', paddingBottom: '50px', backgroundColor: "rgba(255,255,255,0.5)", marginBottom: "50px" }
                }>
                    {windowWide
                        ? <img style={{ alignSelf: "center" }} src={article1Image} alt={""} />
                        : <div>
                            <img style={{ alignSelf: "center" }} src={frame1} alt={""} />
                            <img style={{ alignSelf: "center" }} src={frame2} alt={""} />
                            <img style={{ alignSelf: "center" }} src={frame3} alt={""} />
                        </div>
                    }
                </div>
            </div>
            <Footer />
        </>
    );
};

export default ArticlePage;
